//export const server_url = "http://localhost:2324"
export const server_url = "https://sake.kapsi.fi/blogibackend"
